import { articleSchema, faqSchema, productSchema, eventSchema } from './schemaGenerators';

export function isEmpty(obj: Record<string, unknown>) {
    return Object.keys(obj).length === 0;
}
interface SchemaGenerator {
    data: any;
    schemaType: SchemaType;
}

export type SchemaType =
    | 'FAQPage'
    | 'Article'
    | 'BreadcrumbList'
    | 'Event'
    | 'HowTo'
    | 'LocalBusiness'
    | 'Organization'
    | 'Person'
    | 'Product'
    | 'Recipe'
    | 'VideoObject'
    | 'WebSite'
    | 'none';

export function schemaMarkupGenerator({ data, schemaType }: SchemaGenerator) {
    const baseObj = {
        '@context': 'https://schema.org',
        '@type': schemaType,
    };

    if (isEmpty(data)) {
        return baseObj;
    }
    let preMade;

    switch (schemaType) {
        case 'FAQPage':
            preMade = faqSchema(data);
            break;
        case 'Article':
            preMade = articleSchema(data);
            break;
        case 'Product':
            preMade = productSchema(data);
            break;
        case 'Event':
            preMade = eventSchema(data);
            break;

        default:
            break;
    }

    return preMade || baseObj;
}
